import { useCallbackRef } from "use-callback-ref";
/**
 * @deprecated Use useMergeRefs
 * @param refs
 */
const useCombinedRefs = (...refs) => {
    /**
     * Updates every ref, if combined ref changes see:
     * https://dev.to/thekashey/the-same-useref-but-it-will-callback-8bo
     */
    return useCallbackRef(null, (newCurrent) => {
        refs.forEach((ref) => {
            if (!ref) {
                return;
            }
            if (typeof ref === "function") {
                ref(newCurrent);
            }
            else if (ref.current === null) {
                ref.current = newCurrent;
            }
        });
    });
};
export default useCombinedRefs;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQ29tYmluZWRSZWZzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZUNvbWJpbmVkUmVmcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFFbEQ7OztHQUdHO0FBQ0gsTUFBTSxlQUFlLEdBQUcsQ0FDdEIsR0FBRyxJQUVGLEVBQzJCLEVBQUU7SUFDOUI7OztPQUdHO0lBQ0gsT0FBTyxjQUFjLENBQUksSUFBSSxFQUFFLENBQUMsVUFBVSxFQUFFLEVBQUU7UUFDNUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLEdBQUcsRUFBRSxFQUFFO1lBQ25CLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQztnQkFDVCxPQUFPO1lBQ1QsQ0FBQztZQUNELElBQUksT0FBTyxHQUFHLEtBQUssVUFBVSxFQUFFLENBQUM7Z0JBQzlCLEdBQUcsQ0FBQyxVQUFVLENBQUMsQ0FBQztZQUNsQixDQUFDO2lCQUFNLElBQUksR0FBRyxDQUFDLE9BQU8sS0FBSyxJQUFJLEVBQUUsQ0FBQztnQkFDaEMsR0FBRyxDQUFDLE9BQU8sR0FBRyxVQUFVLENBQUM7WUFDM0IsQ0FBQztRQUNILENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixlQUFlLGVBQWUsQ0FBQyJ9